import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiConstant } from '../app.constant';
import { environment } from 'src/environments/environment';
import { EmailLog } from '../app.model';


@Injectable({
  providedIn: 'root'
})
export class EmailLogsService {

  public baseUrl = `${environment.baseUrl}`;
  constructor(private http: HttpClient) { }


  getEmailLogs(page: number, filters: any = []) {
    let apiUrl = this.baseUrl + apiConstant.EMAIL_LOGS + '?page=' + page;

    if (filters.search != undefined) {
      apiUrl += '&search=' + filters.search;
    }
    if (filters.month != undefined) {
      apiUrl += '&month=' + filters.month;
    }
    if (filters.year != undefined) {
      apiUrl += '&year=' + filters.year;
    }



    return this.http.get<EmailLog>(apiUrl);
  }

}
